export default __webpack_public_path__ + "static/media/Ballroll_00123.b5d42d70.png";